export default "__VITE_ASSET__yPjdFE5J__"